import {Injectable} from '@angular/core';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {RequestOptions} from '@abstract/api.service';
import {TechnicalDeviceApiService} from '@api/technical-device.api.service';
import {RoutesStorage} from '@helpers/routes.helper';

@Injectable()
export class TechnicalDevicesObjectsResolver extends BaseResolverService {
    protected redirectUrl = RoutesStorage.WorkingObject.list;

    constructor(
        service: TechnicalDeviceApiService,
        router: Router,
    ) {
        super(service, router);
    }

    getRequestParams(snapshot: ActivatedRouteSnapshot): RequestOptions {
        const service = this.resolverService as TechnicalDeviceApiService;

        return {
            url: service.getObjectsPath(),
        };
    }

    processNullData() {
        return [];
    }
}
